// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"73e7e4a5","453":"63d2ae84"}[chunkId] + ".chunk.js";
};